const MAX_ATTACHMENT_SIZE = Number(process.env.REACT_APP_MAX_ATTACHMENT_SIZE);


module.exports = MAX_ATTACHMENT_SIZE;